import Markdown from 'react-markdown'
import NextImage from '../../elements/image'
import ButtonLink from '../../elements/button-link'
import { getButtonAppearance } from '../../../utils/button'


export default function Hero({ data }) {
    if (data.smallTextWithLink) return HeroSideBySide({ data });
    return HeroBigPicture({ data });
}

function HeroSideBySide({ data }) {
    return (
        <section className="container">
  <div className="relative overflow-hidden rounded-3xl border border-[#e0b15e]/35 bg-white/55 shadow-sm backdrop-blur">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(244,188,107,0.32),transparent_60%)]" />

    <div className="relative flex flex-col items-center gap-8 px-6 py-10 sm:px-10 lg:flex-row lg:items-center lg:justify-between odd:lg:flex-row-reverse">
      {/* Left column for content */}
      <div className="flex-1 text-center lg:text-left">
        {/* Hero section label */}
        <h2 className="inline-flex rounded-full border border-[#e0b15e]/35 bg-white/60 px-3 py-1 text-xs font-bold tracking-wide text-[#603026] shadow-sm">
          {data.label}
        </h2>

        {/* Big title */}
        <h3 className="title mt-4 text-balance text-3xl font-extrabold tracking-tight text-[#3f2415] sm:text-4xl">
          {data.title}
        </h3>

        {/* Description paragraph */}
        <p className="mt-4 mx-auto max-w-xl text-pretty text-lg font-semibold text-crimson sm:text-xl lg:mx-0">
          {data.description}
        </p>

        {/* Buttons row */}
        <div className="mt-7 flex flex-row flex-wrap gap-3 sm:gap-4 text-crimson place-content-center lg:place-content-start">
          {data.buttons.map((button) => (
            <ButtonLink
              button={button}
              appearance={getButtonAppearance(button.type, "primary")}
              key={button.id}
            />
          ))}
        </div>

        {/* Small rich text */}
        <div className="prose prose-sm sm:prose-base mt-6 rich-text-hero mx-auto max-w-xl text-[#603026] prose-a:font-semibold prose-a:text-[#da3334] hover:prose-a:brightness-110 lg:mx-0">
          <Markdown>{data.smallTextWithLink}</Markdown>
        </div>
      </div>

      {/* Right column for the image */}
      <div className="w-full lg:w-5/12">
        <div className="overflow-hidden rounded-3xl bg-white/40 shadow-sm ring-1 ring-black/5">
          <NextImage media={data.picture} width={640} className="h-auto w-full object-cover" />
        </div>
      </div>
    </div>
  </div>
</section>

    );
}

function HeroBigPicture({ data }) {
    return (
        <section className="relative w-full">
            <div className="relative overflow-hidden rounded-3xl border border-[#e0b15e]/35 bg-white/55 shadow-sm backdrop-blur">
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(244,188,107,0.30),transparent_60%)]" />
                <div className="relative">
                    <div className="px-6 pt-10 text-center sm:px-10">
                        <h1 className="text-chocolate text-balance text-3xl font-extrabold font-[Staatliches] tracking-wider sm:text-4xl lg:text-5xl">
                            {data.title}
                        </h1>
                    </div>
                    <div className="mt-2 px-2 sm:px-6">
                        <div className="overflow-hidden rounded-3xl bg-white/30 shadow-sm ring-1 ring-black/5">
                            <NextImage media={data.picture} className="w-full h-auto object-cover"/>
                        </div>
                    </div>
                    <div className="px-6 pb-10 pt-8 text-center sm:px-10">
                        <p className="mx-auto max-w-2xl text-pretty text-lg text-crimson sm:text-xl md:text-2xl">
                            {data.description}
                        </p>

                {/* Buttons row */}
                                        <div className="mt-7 flex flex-row flex-wrap gap-3 sm:gap-4 text-crimson place-content-center">
                                             {data.buttons.map((button) => (
                         <ButtonLink
                             button={button}
                             appearance={getButtonAppearance(button.type, "primary")}
                             key={button.id}
                         />
                     ))}
                 </div>
                 
                {/* Small rich text */}
                        <div className="prose prose-sm sm:prose-base mt-6 rich-text-hero mx-auto max-w-2xl text-[#603026] prose-a:font-semibold prose-a:text-[#da3334] hover:prose-a:brightness-110">
                            <Markdown>{data.smallTextWithLink}</Markdown>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
